export default "__VITE_ASSET__CwCAEQXx__"